import { createWebHistory, createRouter } from "vue-router"
import routes from "@/config/routerConfig"

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router
